if (!__PRODUCTION__) {
  require('react-hot-loader/patch')
  // https://github.com/gaearon/redux-devtools/commit/64f58b7010a1b2a71ad16716eb37ac1031f93915
}

// IE Object forEach polyfill
if (window && window.NodeList.prototype.forEach === undefined) {
  window.NodeList.prototype.forEach = Array.prototype.forEach
}

// Reload page if ios try to open page with persisted store
window.addEventListener('pageshow', ({ persisted = false }) => {
  if (persisted) window.location.reload()
})
